module.exports = __webpack_public_path__ + "static/media/canaan_anatolia_icon_medium.34d5a605.png";